export enum UserAvailabilityType {
	NONE = 'NONE',
	OWN = 'OWN',
	SPREENG = 'SPREENG',
	BOTH = 'BOTH',
}
